(function () {

    if (window.__bbAddonsLoaded) return;
    window.__bbAddonsLoaded = true;

    // Mystery Box / Tip — select/deselect (radio jaisa). Yeh cart me
    // KUCH bhi add nahi karta khud se — sirf Add to Cart / Buy Now
    // click honay par (agar T-shirt selection complete ho) yeh
    // selection cart me jati hai.
    //
    // PEHLAY: click ko poore card/pill par delegate kar k khud
    // checked-state manage karte thay — is se <label> click par
    // browser khud bhi input pe ek EXTRA click bhej deta hai (yeh
    // normal browser behavior hai), jis se humara click do dafa
    // chal jata tha aur selection apne aap wapis cancel ho jati thi
    // (isi liye "kabhi kabhi select nahi hota" wala masla ho raha
    // tha). AB: native 'change' event use karte hain jo sirf TABHI
    // chalta hai jab checked-state WAQEI badle — bilkul reliable,
    // chahay click kahin bhi (border, icon, text, dot) pe ho.

    var attachedGroups = new WeakSet();

    function syncActiveClasses(container) {

        container.querySelectorAll(".bb-addon-radio").forEach(function (r) {

            r.dataset.wasChecked = r.checked ? "true" : "false";

            var label = r.closest(".bb-addon-card, .bb-tip-pill");

            if (label) label.classList.toggle("active", r.checked);

        });

    }

    function initGroup(container) {

        if (attachedGroups.has(container)) return;
        attachedGroups.add(container);

        // 'change' — jab bhi checked-state genuinely badle (kisi
        // bhi tareeqe se click ho), yahan sirf visuals sync karte
        // hain. Bilkul reliable, double-fire nahi hota.
        container.addEventListener("change", function (event) {

            if (!event.target.classList.contains("bb-addon-radio")) return;

            syncActiveClasses(container);

        });

        // Agar pehlay se checked radio pe dobara click ho (native
        // radio khud deselect nahi karta), to yahan manually
        // deselect kar k 'change' event khud dispatch karte hain
        // taake upar wala sync handler chal jaye.
        container.querySelectorAll(".bb-addon-radio").forEach(function (radio) {

            radio.dataset.wasChecked = radio.checked ? "true" : "false";

            radio.addEventListener("click", function () {

                if (radio.dataset.wasChecked === "true") {
                    radio.checked = false;
                    radio.dispatchEvent(new Event("change", { bubbles: true }));
                }

            });

        });

    }

    function initAll() {
        document.querySelectorAll("[data-bb-group]").forEach(initGroup);
    }

    initAll();

    // Theme editor me block add/edit/reorder karne par yeh container
    // dobara render ho sakta hai — is liye naye groups ko bhi
    // guaranteed pakadne k liye halka sa observer.
    if (window.MutationObserver) {
        new MutationObserver(initAll).observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    // Bundle builder ka guard script isay call karta hai jab Add to
    // Cart / Buy Now click ho aur T-shirt selection complete ho —
    // taake selected Mystery Box / Tip bhi usi order me shamil ho
    // saken. Har group se sirf CURRENTLY selected item wapis karta
    // hai (agar koi select nahi to us group ka kuch bhi nahi jata).
    window.BundleAddonsAPI = {
        getSelectedItems: function () {

            var items = [];

            document.querySelectorAll("[data-bb-group]").forEach(function (group) {

                var checked = group.querySelector(".bb-addon-radio:checked");

                if (!checked) return;

                var variantId = parseInt(checked.dataset.variantId, 10);

                if (variantId && !isNaN(variantId)) {
                    items.push({ id: variantId, quantity: 1 });
                }

            });

            return items;

        }
    };

})();